// Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import LoadingButton from "@mui/lab/LoadingButton";
import {
  Box,
  Card,
  CardContent,
  Container,
  Divider,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { APP_NAME } from "../../config/config";
import { APP_DESC } from "../../config/constant";
import BackgroundImage from "../../assets/images/app-store-login-background.png";
import ProductLogos from "../../assets/images/app-store-login-logos.png";
import logo from "../../assets/images/wso2-logo-black.png";
import { useAppAuthContext } from "../../context/AuthContext";

const LoginScreen = () => {
  const { appSignIn, appSignOut } = useAppAuthContext();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100vw",
        height: "100vh",
        justifyContent: "center",
        backgroundImage: `url(${BackgroundImage})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <Container fixed maxWidth="xs">
        <Card
          elevation={24}
          sx={{
            borderRadius: 3,
            pt: 3,
            mx: 1,
            backgroundColor: "white",
          }}
        >
          <CardContent>
            <Box
              sx={{
                px: 1,
                backgroundColor: "white",
              }}
            >
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                p={1}
              >
                <Grid item xs={12}>
                  <img alt="logo" width="130" height="auto" src={logo}></img>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    align="center"
                    sx={{ fontWeight: "bold" }}
                    variant="h5"
                    color={"black"}
                  >
                    {APP_NAME}
                  </Typography>
                </Grid>
                <Grid item xs={12} sx={{ pb: 2 }}>
                  <Typography
                    align="center"
                    sx={{ fontSize: "1em" }}
                    color={"black"}
                    fontWeight={"400"}
                  >
                    {APP_DESC}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <LoadingButton
                    variant="contained"
                    color="primary"
                    sx={{ fontWeight: "bold" }}
                    onClick={() => {
                      appSignOut();

                      appSignIn();
                    }}
                  >
                    LOG IN
                  </LoadingButton>
                </Grid>
                <Grid item xs={12} mt={6}>
                  <Stack direction="column" spacing={2}>
                    <Typography align="center" color={"black"}>
                      Powered By
                    </Typography>
                    <Stack direction="row" spacing={2}>
                      <img height={22} src={ProductLogos} alt="Product logos" />
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={12} mt={3}>
                  <Typography
                    align="center"
                    color={"grey"}
                    sx={{ fontSize: "0.8em" }}
                  >
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
          <Divider />
        </Card>
      </Container>
    </Box>
  );
};

export default LoginScreen;
